export default __webpack_public_path__ + "media/images/images/icons/mail-chimp-a4b73f855334bd0f856788e637287739.png";